import React from "react";
import Navbar2 from "../Components/Navbar2";
import Footer from "../Components/Footer";

function Advertise() {
  return (
    <>
      <Navbar2 />
      <div className="container-fluid">
        <div className="row">
          <div className="col-12">
            <div className="text-center h1 pt-3">
              Advertise With Us
            </div>
            <div className="row">
              <div className="col">
                  <div className="text-center">
                    <img alt="" src="/s3/led_box_truck1.png"
                    width={700} />
                  </div>
              </div>
              <div className="col">
              <div className="lead text-left">
                  <p>Our digital truck combines cutting-edge LED
                  technology with mobile flexibility to put
                  your brand directly in front of your audience.
                  </p>
                  <p>
                    Our truck features a high-impact digital LED display
                    capable of showcasing still images to full-motion video content
                    that captures attention and drives engagement.
                  </p>
                </div>
            </div>
            </div>
        </div>
      </div>
      <div className="row">
        <div className="col">
          Flexible
Engage and develop a dialogue with
consumers through unlimited creative
implementations.
Time-Sensitive
Digital enables instantaneous creative
updates and the ability to respond in
real-time to current events and market
conditions.
Targeted
Impact specific geographic and
demographic audiences close to the point of
sale.
Efficient
Optimize ad spend and work synergistically
with other media to enhance ROI.
        </div>
      </div>
      <div className="row">
        <div className="col-6">
          <table class="table table-striped table-bordered align-middle">
            <thead class="table-dark">
              <tr>
                <th scope="col">Duration</th>
                <th scope="col">Rate Per Day</th>
                <th scope="col">Total Cost</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>7 Days</td>
                <td>$1,600 per day</td>
                <td><strong>$11,200</strong></td>
              </tr>
              <tr>
                <td>14 Days</td>
                <td>$1,400 per day</td>
                <td><strong>$19,600</strong></td>
              </tr>
              <tr>
                <td>28 Days</td>
                <td>$1,100 per day</td>
                <td><strong>$30,800</strong></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <Footer />
    </>
  );
}

export default Advertise;
